import Slide from '@/components/shared/Slide';
import { PROVIDER_BRAND } from '@/data/provider-brand';
import type { RoadmapCompanyConfig, ViewMode } from '@/types/roadmap.types';

interface Props {
  config: RoadmapCompanyConfig;
  mode: ViewMode;
}

export default function CoverSlide({ config, mode }: Props) {
  const { company, proposal, clientBrand } = config;
  return (
    <Slide mode={mode}>
      <div className="w-full text-center">
        {clientBrand?.logo && (
          <div className="mb-8">
            <img
              src={clientBrand.logo}
              alt={clientBrand.companyName}
              className="h-14 mx-auto"
            />
          </div>
        )}
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-6">
          Grant Funding Proposal
        </p>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight text-foreground mb-4">
          {company.name}
        </h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed mb-10">
          {proposal.engagement_scope}
        </p>
        <div className="flex items-center justify-center gap-6 text-sm text-muted-foreground mb-8">
          <span>
            Prepared by{' '}
            <strong className="text-foreground">{proposal.consultant.name}</strong>
            , {proposal.consultant.title}
          </span>
          <span className="w-px h-4 bg-border" />
          <span>{proposal.time_horizon}</span>
        </div>
        <div className="flex items-center justify-center gap-2 opacity-50">
          <img
            src={PROVIDER_BRAND.logo}
            alt={PROVIDER_BRAND.companyName}
            className="h-5"
          />
        </div>
      </div>
    </Slide>
  );
}
